
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceOutwardGrid extends _Ext.GridBase<ServiceOutwardRow, any> {
        protected getColumnsKey() { return 'Finance.ServiceOutward'; }
        protected getDialogType() { return ServiceOutwardDialog; }
        protected getIdProperty() { return ServiceOutwardRow.idProperty; }
        protected getInsertPermission() { return ServiceOutwardRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceOutwardRow.localTextPrefix; }
        protected getService() { return ServiceOutwardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(96);
            this.editItem(<ServiceOutwardRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(),
                CreatedBy: userDefinition.UserId,
                VoucherTypeId: 96,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId, 
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                EnteredBy: userDefinition.Username,
                
            });
        }
    }
}